import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const ProfileTop = ({
  profile: {
    status,
    bio,
    social,
    user: { name, email, avatar }
  },
  usersProfile
}) => {
  return (
    <Fragment>
      <div className="card rounded-0 my-3 shadow-sm">
        <div className="card-body">
          {usersProfile && (
            <Fragment>
              <Link
                to="/dashboard"
                className="text-secondary float-right m-0 p-0"
              >
                <i className="far fa-edit"></i>
              </Link>
            </Fragment>
          )}

          <div className="d-flex justify-content-md-center">
            <div className="edit-pic">
              <img
                src={avatar}
                className="profile-page-pic"
                // style={{ height: '85px', width: '85px' }}
                alt=""
              />
            </div>
            <div className="ml-3 align-self-center">
              <h6 className="mb-0">{name}</h6>
              <span className="text-muted username rb">{email}</span>
              <div className="social">
                {social && social.facebook && (
                  <a
                    href={social.facebook}
                    target="_blank"
                    rel="noopener noreferrer"
                    className=""
                  >
                    <i className="fab fa-facebook-square facebook"></i>
                  </a>
                )}
                {social && social.twitter && (
                  <a
                    href={social.twitter}
                    target="_blank"
                    rel="noopener noreferrer"
                    className=""
                  >
                    <i className="fab fa-twitter twitter"></i>
                  </a>
                )}
                {social && social.instagram && (
                  <a
                    href={social.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    className=""
                  >
                    <i className="fab fa-instagram instagram"></i>
                  </a>
                )}
                {social && social.linkedin && (
                  <a
                    href={social.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className=""
                  >
                    <i className="fab fa-linkedin linkedin"></i>
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

ProfileTop.defaultProps = {
  usersProfile: false
};

ProfileTop.propTypes = {
  profile: PropTypes.object.isRequired,
  usersProfile: PropTypes.bool
};

export default ProfileTop;
